import styled from "styled-components";
import { mobile } from "../../design-system/tokens/breakpoints";

// The card shell — border, radius, shadow, background. Use this as the outermost
// wrapper wherever a card surface is needed. PathwaySectionCard composes this.
export const PathwayCard = styled.section`
    background: var(--surface-card);
    border: 1px solid var(--border-hairline);
    border-radius: var(--pw-radius-2xl);
    box-shadow: var(--pw-shadow-xs);
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const PathwayCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--gap-l);
    padding: var(--gap-xl) var(--gap-xxl);
    background: var(--surface-card);
    ${mobile} {
        flex-wrap: wrap;
        padding: var(--gap-l) var(--gap-xl);
    }

    & > h1, & > h2, & > h3, & > h4, & > h5, & > h6, & > p {
        margin: 0;
        font-size: var(--pw-text-card);
        font-weight: var(--pw-weight-bold);
        color: var(--text-heading);
    }
`;

export const PathwayCardBody = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: var(--gap-xxl);

    /* When immediately following a header, drop the top padding — the header
       already has its own bottom padding, so keeping both creates double spacing. */
    ${PathwayCardHeader} + & {
        padding-top: 0;
    }

    & p {
        margin: 0;
    }
`;

export const PathwayButtonRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--gap-m);
    justify-content: flex-end;
`;
